export class UserSymbolState {
  userSymbolsList: any[] = [];
}
